'use strict';

/**
 * Ordlista Listing Block JavaScript
 */
function initOrdlistaListing(block) {
	if (!block || block.dataset.ordlistaInit) return;
	block.dataset.ordlistaInit = '1';

	var blockId = block.id;
	var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÅÄÖ'.split('');
	var alphabetFilter = block.querySelector('.ordlista-listing__alphabet-filter');
	var searchInput = block.querySelector('.ordlista-search-input');
	var ordlistaTerms = block.querySelector('.ordlista-listing__terms');
	var noResults = block.querySelector('.ordlista-listing__no-results');
	var letterGroups = block.querySelectorAll('.ordlista-listing__letter-group');

	// Get available letters from DOM
	var availableLetters = [];
	letterGroups.forEach(function(group) {
		availableLetters.push(group.getAttribute('data-letter'));
	});

	function setActiveButton(activeBtn) {
		alphabetFilter.querySelectorAll('button').forEach(function(btn) {
			btn.classList.remove('active');
		});
		activeBtn.classList.add('active');
	}

	// Create alphabet buttons
	alphabet.forEach(function(letter) {
		var button = document.createElement('button');
		button.type = 'button';
		button.textContent = letter;
		button.setAttribute('data-letter', letter);

		if (availableLetters.includes(letter)) {
			button.addEventListener('click', function() {
				var heading = block.querySelector('#letter-' + letter + '-' + blockId);
				if (heading) {
					window.scrollTo({
						top: heading.getBoundingClientRect().top + window.pageYOffset - 100,
						behavior: 'smooth'
					});
					setActiveButton(button);
				}
			});
		} else {
			button.style.opacity = '0.3';
			button.style.cursor = 'not-allowed';
		}

		alphabetFilter.appendChild(button);
	});

	// Search functionality
	if (searchInput) {
		searchInput.addEventListener('input', function() {
			var searchTerm = this.value.toLowerCase().trim();

			if (searchTerm === '') {
				letterGroups.forEach(function(group) {
					group.style.display = '';
					group.querySelectorAll('.ordlista-listing__term-item').forEach(function(term) {
						term.style.display = '';
					});
				});
				ordlistaTerms.style.display = '';
				noResults.style.display = 'none';
				return;
			}

			var hasResults = false;

			letterGroups.forEach(function(group) {
				var terms = group.querySelectorAll('.ordlista-listing__term-item');
				var groupHasVisibleTerms = false;

				terms.forEach(function(term) {
					var title = (term.getAttribute('data-term') || '').toLowerCase();

					if (title.includes(searchTerm)) {
						term.style.display = '';
						groupHasVisibleTerms = true;
						hasResults = true;
					} else {
						term.style.display = 'none';
					}
				});

				group.style.display = groupHasVisibleTerms ? '' : 'none';
			});

			if (hasResults) {
				ordlistaTerms.style.display = '';
				noResults.style.display = 'none';
			} else {
				ordlistaTerms.style.display = 'none';
				noResults.style.display = '';
			}
		});

		// Clear search on Escape key
		searchInput.addEventListener('keydown', function(e) {
			if (e.key === 'Escape') {
				this.value = '';
				this.dispatchEvent(new Event('input'));
			}
		});
	}
}

// Initialize on frontend
document.addEventListener('DOMContentLoaded', function() {
	document.querySelectorAll('.ordlista-listing').forEach(initOrdlistaListing);
});

// Initialize on ACF Block Editor preview render
if (window.acf) {
	window.acf.addAction('render_block_preview/type=ordlista-listing', function($block) {
		initOrdlistaListing($block[0]);
	});
}
